import { render, staticRenderFns } from "./line_maze.config.vue?vue&type=template&id=9c457048"
import script from "./line_maze.config.vue?vue&type=script&lang=js"
export * from "./line_maze.config.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../app/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports